import React from "react";
import htmlCss from "../../assets/tech/htmlCss.svg";
import js from "../../assets/tech/js.png";
import ts from "../../assets/tech/ts.png";
import reactNext from "../../assets/tech/reactNext.svg";
import bootstrap from "../../assets/tech/bootstrap5.jpeg";
import tailwind from "../../assets/tech/tailwind css.png";
import laptop1 from "../../assets/about/laptopcoffe.jpg";

const About = () => {
  return (
    <div id="about" className="bg-white py-24 lg:py-32 px-6 md:px-12 lg:px-2">
      <div className="lg:max-w-[1100px] mx-auto ">
        <h2 className="text-center text-2xl text-[#2979ff] font-bold tracking-[.10em]">
          ABOUT ME
        </h2>
        <div className="flex flex-col lg:flex-row justify-between items-center gap-12 mt-16">
          <div className="flex-1">
            <img src={laptop1} alt="" className="rounded-xl" />
          </div>
          <div className="flex-1">
            <p className=" text-lg text-justify">
              👋 Hello there! I'm Bikash Devsharma, a passionate front-end web
              developer with a creative flair and a penchant for crafting
              visually stunning and user-friendly websites.
            </p>

            <p className="pt-4 text-lg text-justify">
              💡 I'm currently improving my skills in Redux and Next.js, along
              with my expertise in React, Javascript, TypeScript, Tailwind CSS
              and Bootstrap 🚀.
            </p>

            <h3 className="text-2xl font-bold mt-5">Tech Stack</h3>
            <div className="pt-5 flex gap-7 flex-wrap">
              <img
                src={htmlCss}
                alt=""
                className="transition-transform duration-500 transform hover:-translate-y-2"
              />

              <div className="flex gap-2 transition-transform duration-500 transform hover:-translate-y-2">
                <img src={js} alt="" className="w-[50px] rounded-xl" />
                <img src={ts} alt="" className="w-[50px] rounded-xl" />
              </div>

              <img
                src={reactNext}
                alt=""
                className="transition-transform duration-500 transform hover:-translate-y-2"
              />
              <div className="flex gap-2 transition-transform duration-500 transform hover:-translate-y-2">
                <img src={tailwind} alt="" className="w-[50px] rounded-xl" />
                <img src={bootstrap} alt="" className="w-[50px] rounded-xl" />
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </div>
    </div>
  );
};

export default About;
